import {
  styleAttr,
  styleAttrUi,
  ComponentAdmin,
  ModuleCategory,
  SubscribesTo,
} from '@backstage-components/base';
import {Static, Type} from '@sinclair/typebox';

export const reactName = 'RichText';
export const name = 'Rich Text';
export const description = reactName;
const category: ModuleCategory = 'typography';

export const schema = Type.Object(
  {
    content: Type.String({title: 'Content Markup'}),
    styleAttr: Type.Optional(Type.Ref(styleAttr)),
  },
  {definitions: {styleAttr}}
);

// eslint-disable-next-line @typescript-eslint/no-inferrable-types
const richTextStyles: string = `
  font-family: SF UI Text,Roboto,Helvetica Neue,Helvetica,sans-serif;
  line-height: 1.25;

  h1, h2, h3, h4, h5, h6 {
    font-family: SF UI Text,Roboto,Helvetica Neue,Helvetica,sans-serif;
    font-weight: 500;
    line-height: 1.25;
    margin-top: 1em;
    margin-bottom: 0.5em;
  }

  p {
    font-size: 1rem;
  }

  dl, ol, ul, p {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  dl, ol, ul {
    padding-inline-start: 2.5rem;
  }

  pre, code, samp {
    font-family: Source Code Pro,Consolas,monospace;
    font-size: 0.875rem;
  }

  pre {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    overflow-x: scroll;
  }

  h1 { font-size: 2rem; }
  h2 { font-size: 1.5rem; }
  h3 { font-size: 1.25rem; }
  h4 { font-size: 1rem; }
  h5 { font-size: 0.875rem; }
  h6 { font-size: 0.75rem; }
`;

export type SchemaType = Static<typeof schema>;

export const uiSchema = {
  content: {
    'ui:widget': 'modalTextareaWidget',
    'ui:options': {
      buttonTitle: 'Content',
      editor: 'TinyMCE',
      /**
       * Hard coding this api key as a stop gap since TinyMCE has other safeguards in place around which domains can be whitelisted to display the rich text editor.
       * Planning to remove this api key as part of https://lcdigital.atlassian.net/browse/DLB-1402
       */
      tinyApiKey: 'mb6fyq4wtavfomcdjm3guo04keatf4msk5b5sd1p81pvtdrw',
      editorStyles: richTextStyles,
    },
  },
  ...styleAttrUi,
};

export const defaultFieldData: SchemaType = {
  content:
    '<h2>This is a heading</h2><p>This is a paragraph. Add your content here.</p>',
  styleAttr: richTextStyles,
};

export const instructions = Type.Union([
  SubscribesTo({
    topic: `${reactName}:set-content`,
    description: 'Sets the HTML content',
    meta: {
      content: Type.String(),
    },
  }),
]);

export const ComponentDefinition: ComponentAdmin = {
  id: 'c674b76d-f7e3-4f55-9003-29c66ab28847',
  reactName,
  name,
  slug: reactName,
  description,
  version: 1,
  defaultFieldData,
  slotConfiguration: {},
  schema,
  uiSchema,
  category,
  instructions,
};
